module.exports = __webpack_public_path__ + "static/img/bg_partner.aa99b32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_partner.jpg
// module id = 3WZx
// module chunks = 1